<template>
    <div :class='{"help-block":true, "small":closed}'>
        <div class="left_info_icon">
            <svg width="30px" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg" role="img" aria-hidden="true" data-icon="question-circle"
                 class="">
                <path style="fill: #4368E0;" fill="currentColor"  d="M504 256c0 136.997-111.043 248-248 248S8 392.997 8 256C8 119.083 119.043 8 256 8s248 111.083 248 248zM262.655 90c-54.497 0-89.255 22.957-116.549 63.758-3.536 5.286-2.353 12.415 2.715 16.258l34.699 26.31c5.205 3.947 12.621 3.008 16.665-2.122 17.864-22.658 30.113-35.797 57.303-35.797 20.429 0 45.698 13.148 45.698 32.958 0 14.976-12.363 22.667-32.534 33.976C247.128 238.528 216 254.941 216 296v4c0 6.627 5.373 12 12 12h56c6.627 0 12-5.373 12-12v-1.333c0-28.462 83.186-29.647 83.186-106.667 0-58.002-60.165-102-116.531-102zM256 338c-25.365 0-46 20.635-46 46 0 25.364 20.635 46 46 46s46-20.636 46-46c0-25.365-20.635-46-46-46z"></path>
            </svg>
        </div>
        <template v-if="closed">
            <a class="layout-row" @click="close(false)">
                <h2 class="title flex">Learn more about {{title.toLowerCase()}}</h2>
            </a>
        </template>
        <template v-else>
            <div class="layout-row">
                <h2 class="title flex">{{title}}</h2>
                <a class="close_btn" @click="close(true)">
                    <inline-svg :src="require('@/assets/img/popup_close.svg')"/>
                </a>
            </div>
            <div class="description" v-html="description">
            </div>
            <ul v-if="links" class="links">
                <li v-for="link in links" :key="link.id" >
                    <a target="_blank" :href="link.url" >{{link.title}}</a>
                </li>
            </ul>
        </template>

    </div>
</template>

<script >
    export default {
        name: "HelpBlock",
        props: ["description", "title", "links", "name"],

        data() {
            return {
                closed: false,
            }
        },
        computed: {
        },
        methods: {
            close(closed) {
                this.closed = closed;
                this.$cookies.set(`${this.name}.is_closed`, closed);
                this.$emit('closed', closed);
            },
        },

        created() {
            this.closed = this.$cookies.get(`${this.name}.is_closed`);
        }
    };
</script>

<style lang="scss" scoped>
    .help-block {
        position: relative;
        padding: 15px 70px;
        background: #D5E5FF;
        border-radius: 12px;
        margin-bottom: 50px;

        .title {
            font-weight: 400;
            font-size: 20px;
            color: rgba(0,0,0,.55);
            letter-spacing: 0;
        }
        &.small {
            &:hover {
                text-decoration: underline;
            }
            .title {
                font-size: 16px;
                line-height: 26px;
            }
        }
        .description {
            margin-top: 10px;
            margin-right: 40px;
        }
        .description p {
            font-weight: normal;
            font-size: 15px;
            line-height: 150%;
            color: #636A7B;
            margin: 0;
            margin-bottom: 10px;
        }
        .links {
            list-style: none!important;
            margin-top: 10px;
            a {
                color: rgba(0,0,0,.55);
                text-decoration: underline;
            }
        }
        .left_info_icon {
            position: absolute;
            left: 20px;
            top: 16px;
            svg {
                width: 28px;
                height: 28px;
                path {
                    fill: #4368E0;
                }
            }
        }
        .close_btn {
            position: absolute;
            right: 25px;
            top: 19px;
            svg path {
                fill: #97AACD;
            }
        }
    }
</style>
